import React from 'react';

// Styles
import styles from "./../StaffManagment.module.css";

// Images
import folderGreenIcon from "./../../../../assets/img/DashboardICons/folderGreenIcon.svg";

const StaffActivityNotif = (props) => {
    return (
        <div dir="rtl" className={`mt-3 pt-2 mx-4 px-2 d-flex justify-content-between`}>
            <div className={`p-3 w-100 d-flex align-items-center justify-content-start ${styles.total_staff_activity_notif_box}`}>
                <img className={`${styles.icon_staff_activity_notif_box}`} src={folderGreenIcon} alt="people-green-icon" />
                <h3 className={`pe-4 text-right mb-0 ${styles.title_staff_activity_notif_box}`}> تعداد فایل های مجاز برای هر مشاور </h3>
                <div style={{ color: "#21409a" }} className={`ms-4 me-auto`} role="button" onClick={() => props.setModalLimitFiles(true)}>
                    ویرایش
                </div>
            </div>
        </div>
    )
}

export default StaffActivityNotif